import { stripAllPua } from "@nijiurachan/pua-command";
import { getPostPlainBody, type Post } from "@/entities/post";

/**
 * 本文にpoll選択肢を続けた、コピー・読み上げ・NG・export向けテキスト。
 * 検索、引用解決、OGP抽出は従来どおり本文だけを正本とする。
 */
export function getPostPlainTextWithPoll(
  post: Pick<Post, "body" | "poll">,
): string {
  const body = getPostPlainBody(post);
  const options = post.poll?.options.map((option) => stripAllPua(option.label));
  return options && options.length > 0
    ? `${body}\n${options.join("\n")}`
    : body;
}
